import gql from 'graphql-tag';

export default {
    STUDENT_QUERY: gql`
        query Student($studentId: String, $email: String, $mobilePhone: String) {
            student(studentId: $studentId, email: $email, mobilePhone: $mobilePhone) {
                id,
                email,
                name,
                firstName,
                lastName,
                phone,
                mobilePhone,
            }
        }`,
    STUDENT_MUTATION: gql`
        mutation Student($firstName: String, $lastName: String, $email: String, $phone: String, $mobilePhone: String){
            student(firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, mobilePhone: $mobilePhone) {
                id,
            }
        }`,
};



// WEBPACK FOOTER //
// ./src/graphql-operations/students.graphql.js